import { render, staticRenderFns } from "./list-filter.vue?vue&type=template&id=024b437e"
import script from "./list-filter.vue?vue&type=script&lang=js"
export * from "./list-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports